module.exports = __webpack_public_path__ + "static/media/O-white.afc3d019.svg";